import processEnv from "../processEnv";

const fetchFareOptionsQuery = (
  mainRequestId: string,
  partial1Id: string,
  partial2Id: string
) => {
  console.log("MAIN PAR OFFER ID: ", mainRequestId);
  console.log("PARTIAL 1 OFFER ID: ", partial1Id);
  console.log("PARTIAL 2 OFFER ID: ", partial2Id);

  return fetch(
    `https://api.duffel.com/air/partial_offer_requests/${mainRequestId}/fares?selected_partial_offer=${partial1Id}&selected_partial_offer=${partial2Id}`,
    {
      method: "GET",
      referrerPolicy: "no-referrer",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers":
          "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip",
        Accept: "application/json",
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Duffel-Version": "v1",
        Authorization:
          "Bearer duffel_test_0D60g6XG_fY4RvLUMRtRQN5MaLzAGG2YnXuIWM9qu2p",
      },
    }
  );
};

export default fetchFareOptionsQuery;
